import { render, staticRenderFns } from "./category-details.vue?vue&type=template&id=141bbc0e"
import script from "./category-details.vue?vue&type=script&lang=js"
export * from "./category-details.vue?vue&type=script&lang=js"
import style0 from "./category-details.vue?vue&type=style&index=0&id=141bbc0e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports